var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about-us"},[_c('div',{staticClass:"content"},[_c('h3',{staticClass:"title"},[_vm._v(_vm._s(_vm.info.title))]),_c('p',{staticClass:"desc"},[_vm._v(_vm._s(_vm.info.createdAt))]),_c('div',{staticClass:"line"}),_c('div',{staticClass:"message-content",domProps:{"innerHTML":_vm._s(_vm.info.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }